import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service'
import { SCENE_STATUS } from '../../conf/scene';

@Component({
    selector: 'app-scene-strip',
    templateUrl: './scene-strip.component.html',
    styleUrls: ['./scene-strip.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SceneStripComponent implements OnInit {

	@Input() item: any;
	@Input() zoom: number = 1;
	@Input() showEllipsis: boolean = false;
	@Input() showMobileMenu: boolean = false;

	@Output() onActionMenu = new EventEmitter<any>();

	SCENE_STATUS = SCENE_STATUS;
	tooltipText: string;
	isSelected: boolean = false;

	toggleSelected(ev) {
		this.isSelected = ev;
	}

	constructor(
		public _gS: GlobalService
	) { }

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.item) {
			this.setCharacters();
			this.tooltipText =
				`${this.item.chapter_number}/${this.item.scene_number} ${this.item.scene_header_eng}
				<br>${this.item.charactersList ? this.item.charactersList : ''}
				<br>${this.item.description ? this.item.description : ''}
				`;

			this.item.class = this._gS.getSceneDayNightIntExtClass(this.item.scene_day_night_option_id, this.item.scene_interior_exterior_option_id, this.item);
			this.item.class_scn_status = this._gS.checkSceneClass(this.item);
		}
	}

	setCharacters(){
		if(this.item.characters){
			let listCharacters = [];
			this.item.characters.map(char => char.character_name ? listCharacters.push(char.character_name) : null );
			this.item.charactersList = listCharacters.join(', ');
		}
	}

	onContextMenu(ev) {
		this.onActionMenu.emit(ev);
	}
}
